import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

export default class Header extends Component {
	render() {
		return (
			<header class={style.header}>
				<h1>Mouthful Admin Panel</h1>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js